import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TuiTextfieldControllerModule, TuiTextareaModule, TuiInputModule } from '@taiga-ui/legacy';
import { TuiAvatar, TuiBlock, TuiCheckbox, TuiButtonLoading } from '@taiga-ui/kit';
import { TuiIcon, TuiButton } from '@taiga-ui/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SharedModule } from '@src/app/shared';
import { WaitTelegramChatsModule } from '@src/app/modules/wait-telegram-chats';
import { IconModule } from '@src/app/modules/icon';
import { PhotoModule } from '@src/app/modules/photo';
import { SearchUsersModule } from '@src/app/modules/search-users';
import { UsersListModule } from '@src/app/modules/users-list';

import { GroupInfoComponent } from './group-info.component';
import { GroupInfoViewComponent } from './group-info-view/group-info-view.component';
import { GroupInfoService } from './group-info.service';

@NgModule({
  declarations: [GroupInfoComponent, GroupInfoViewComponent],
  imports: [
    CommonModule,
    FormsModule,
    IconModule,
    NgxPermissionsModule,
    PhotoModule,
    ReactiveFormsModule,
    SearchUsersModule,
    SharedModule,
    TuiAvatar,
    TuiButton,
    TuiBlock,
    TuiCheckbox,
    TuiInputModule,
    TuiTextareaModule,
    TuiTextfieldControllerModule,
    UsersListModule,
    WaitTelegramChatsModule,
    TuiIcon,
    TuiButtonLoading,
  ],
  exports: [GroupInfoComponent],
  providers: [GroupInfoService],
})
export class GroupInfoModule {}
